import React from "react";
import styled from "styled-components";
import { colors } from "./colors";
import { formatCompact, formatSignedPercent, pctChange } from "./format";
import { MONO } from "./Row";
import { Part, PartTitle, PartNote } from "./Part";
import { measureOf } from "./drops";

export default function SectionLossBars({ sections, measure, onSelect }) {
    const { unit } = measureOf(measure);
    const rows = sections
        .map((section) => ({ ...section, lost: section.before - section.after, change: pctChange(section.before, section.after) }))
        .sort((a, b) => b.lost - a.lost);
    const maxLost = Math.max(...rows.map((row) => row.lost), 1);
    const totalLost = rows.reduce((total, row) => total + row.lost, 0);

    return (
        <Part>
            <PartTitle>Lost {unit} by section</PartTitle>
            <PartNote><strong>−{formatCompact(totalLost)}</strong> {unit}/wk · select to filter drops</PartNote>
            <List>
                {rows.map((row) => (
                    <li key={row.directory}>
                        <Item type="button" onClick={() => onSelect(row.directory)}>
                            <Directory>{row.directory}</Directory>
                            <Track><Fill style={{ width: `${Math.max(2, (row.lost / maxLost) * 100)}%` }} /></Track>
                            <Figures><strong>−{formatCompact(row.lost)}</strong><span>{formatSignedPercent(row.change, 0)}</span></Figures>
                        </Item>
                    </li>
                ))}
            </List>
        </Part>
    );
}

const List = styled.ul`
    margin: 16px 0 0;
    padding: 0;
    list-style: none;
`;

const Item = styled.button`
    display: grid;
    grid-template-columns: 88px minmax(0, 1fr) 96px;
    align-items: center;
    gap: 12px;
    width: calc(100% + 16px);
    margin: 0 -8px 2px;
    padding: 8px;
    border: none;
    border-radius: 6px;
    background: none;
    text-align: left;
    cursor: pointer;
    &:hover { background: ${colors.canvas}; }
`;

const Directory = styled.span`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: ${MONO};
    font-size: 12px;
    color: ${colors.ink};
`;

const Track = styled.span`
    height: 8px;
    overflow: hidden;
    border-radius: 999px;
    background: ${colors.line}b3;
`;

const Fill = styled.span`
    display: block;
    height: 100%;
    border-radius: 999px;
    background: ${colors.critical};
`;

const Figures = styled.span`
    text-align: right;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
    strong { font-weight: 500; color: ${colors.ink}; }
    span { margin-left: 6px; color: ${colors.muted}; }
`;
